/*
Copyright (c) 2015, salesforce.com, inc. All rights reserved.
Copyright (c) 2018, Picsa Advisory Services (Pty) Ltd. All rights reserved.

Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
Neither the name of salesforce.com, inc. nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS 'AS IS' AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES LOSS OF USE, DATA, OR PROFITS OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/

import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom'
import { Mutation } from 'react-apollo'
import qs from 'query-string'
import moment from 'moment'

import {
  Button,
  TabbedView,
  FilterSidebar,
  // FileList,
  RequestRunList,
  Picklist,
  DynamicPicklist,
  DateRange,
  BulkFileUploader,
  Modal,
  SvgIcon,
  // Spinner,
  // Warning,
  FilterComboEmployerDivision,
  FilterSidebarItem,
  PicklistWithData
} from '../components'

import {
  // QUERY_FILETYPE,
  QUERY_REQUESTTYPES
} from '../queries'

import { MUTATION_REQUESTRUN } from '../mutations'

import { AccountContext } from '../context'

// const QUERY_CASEHANDLERS = gql`
//   query {
//     responsibilities(description_Icontains: "handle_cases", orderBy: "identity__first_name") {
//       edges {
//         node {
//           id
//           identity {
//             id
//             firstName
//             lastName
//           }
//         }
//       }
//     }
//   }
// `

const getInitialState = (statusFilterInSidebar, location, updatedAtSortDefaultDesc) => {
  const defaultState = {
    statusFilter: statusFilterInSidebar
      ? null
      : 'uncaptured', //'unclassified',
    fileTypeFilter: null,
    employerFilter: null,
    divisionFilter: null,
    createdAtFromFilter: null,
    createdAtToFilter: null,
    updatedAtFromFilter: null,
    updatedAtToFilter: null,
    requestTypeFilter: null,
    requestRunOriginFilter: null,
    requestTypeSourceFilter: null,
    processedFilter: statusFilterInSidebar
      ? null
      : 'no',
    assignedToFilter: null,
    idleForFilter: null,
    idleForDate: null,
    orderBy: statusFilterInSidebar
      ? `${updatedAtSortDefaultDesc ? '-' :''}updated_at`
      : '-created_at',
    showFilesUploadModal: false,
    showNewRequestModal: false,
    newRequestRequestType: null,
    refreshTimestamp: moment().unix()
  }

  if (location.search.length > 0) {
    return { ...defaultState, ...getFiltersFromQueryString(location.search) }
  } else {
    return defaultState
  }
}

const getFiltersFromQueryString = (queryString) => {
  let queryParams = qs.parse(queryString)

  let filters = Object.assign(
    {},
    ...Object.keys(queryParams).map(key => (  // ES6 way of assigning renamed object keys
      [ 'search', 'orderBy' ].indexOf(key) > -1
        ? { [key]: queryParams[key] }
        : key === 'processed'
          ? { processedFilter: queryParams[key] === 'Yes' }
          : [  'createdAtFrom', 'createdAtTo', 'updatedAtFrom', 'updatedAtTo' ].indexOf(key) > -1
            ? { [`${key}Filter`]: moment(queryParams[key], 'YYYYMMDDTHHmm') }
            : { [`${key}Filter`]: queryParams[key] }
    ))
  )

  return filters
}


class Requests extends React.PureComponent {
  static propTypes = {
    identityId: PropTypes.string,
    statusFilterInSidebar: PropTypes.bool,
    title: PropTypes.element,
    showRequestStatusColumn: PropTypes.bool,
    updatedAtSortDefaultDesc: PropTypes.bool
  }

  static defaultProps = {
    title: <Fragment>
        <SvgIcon
          variant='utility'
          symbol='side_list'
          colour='light'
          rotateDegrees={180}
          className='slds-m-right_medium slds-m-top_x-small'
        />
        <div className='slds-m-top_small u-font-size-x-large u-text-caps'>
          Requests
        </div>
      </Fragment>,
    statusFilterInSidebar: false,
    updatedAtSortDefaultDesc: false
  }

  state = getInitialState(this.props.statusFilterInSidebar, this.props.location, this.props.updatedAtSortDefaultDesc)

  componentDidMount() {
    if (this.props.location.search.length === 0) {
      this.setQueryString(true)
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.location.search !== this.props.location.search) {
      let cleanState = {
        statusFilter: this.props.statusFilterInSidebar
          ? null
          : 'uncaptured', //'unclassified',
        fileTypeFilter: null,
        employerFilter: null,
        divisionFilter: null,
        createdAtFromFilter: null,
        createdAtToFilter: null,
        updatedAtFromFilter: null,
        updatedAtToFilter: null,
        requestTypeFilter: null,
        requestRunOriginFilter: null,
        requestTypeSourceFilter: '',
        processedFilter: this.props.statusFilterInSidebar
          ? null
          : 'no',
        assignedToFilter: null,
        idleForFilter: null,
        idleForDate: null,
        orderBy: '',
        showFilesUploadModal: false,
        showNewRequestModal: false,
        newRequestRequestType: null
      }
      this.setState({ ...cleanState, ...getFiltersFromQueryString(this.props.location.search) })
    }
  }

  setQueryString = (firstRender) => {
    let { orderBy, statusFilter, processedFilter, fileTypeFilter, employerFilter, divisionFilter,
      createdAtFromFilter, createdAtToFilter, updatedAtFromFilter, updatedAtToFilter, requestTypeFilter,
      requestRunOriginFilter, requestTypeSourceFilter, assignedToFilter, idleForFilter } = this.state

    let filters = {
      processed: processedFilter === 'yes' ? 'Yes' : 'No'
    }

    if (orderBy) {
      filters.orderBy = orderBy
    }

    if (statusFilter) {
      filters.status = statusFilter === 'on hold'
        ? 'on_hold'
        : statusFilter
    }

    if (fileTypeFilter) {
      filters.fileType = fileTypeFilter
    }

    if (employerFilter) {
      filters.employer = employerFilter
    }
    if (divisionFilter) {
      filters.division = divisionFilter
    }

    if (createdAtFromFilter) {
      filters.createdAtFrom = createdAtFromFilter.format('YYYYMMDDTHHmm')
    }
    if (createdAtToFilter) {
      filters.createdAtTo = createdAtToFilter.format('YYYYMMDDTHHmm')
    }

    if (updatedAtFromFilter) {
      filters.updatedAtFrom = updatedAtFromFilter.format('YYYYMMDDTHHmm')
    }
    if (updatedAtToFilter) {
      filters.updatedAtTo = updatedAtToFilter.format('YYYYMMDDTHHmm')
    }

    if (requestTypeFilter) {
      filters.requestType = requestTypeFilter
    }

    if (requestRunOriginFilter) {
      filters.requestRunOrigin = requestRunOriginFilter
    }

    if (requestTypeSourceFilter) {
      filters.requestTypeSource = requestTypeSourceFilter
    }

    if (assignedToFilter) {
      filters.assignedTo = assignedToFilter
    }

    if (idleForFilter) {
      filters.idleFor = idleForFilter
    }

    if (firstRender) {
      this.props.history.replace({ search: qs.stringify(filters) })
    } else {
      this.props.history.push({ search: qs.stringify(filters) })
    }
  }

  getCaseHandlers = (responsibilities) => {
    let caseHandlers = {}
    caseHandlers['Anyone'] = ''
    responsibilities.edges.forEach((responsibility) => (
      caseHandlers[responsibility.node.identity.firstName + ' ' + responsibility.node.identity.lastName] =
      responsibility.node.identity.id
    ))
    return caseHandlers
  }

  handleIdleForChoice = (idleForChoice) => {
    switch(idleForChoice) {
      case 'For more than 14 days':
        this.setState({
          idleForDate: moment().subtract(14, 'days').utc(),
          idleForFilter: idleForChoice,
          updatedAtFromFilter: null,
          updatedAtToFilter: null
        }, this.setQueryString)
        break

      case 'For more than 7 days':
        this.setState({
          idleForDate: moment().subtract(7, 'days').utc(),
          idleForFilter: idleForChoice,
          updatedAtFromFilter: null,
          updatedAtToFilter: null
        }, this.setQueryString)
        break

      case 'For more than a day':
        this.setState({
          idleForDate: moment().subtract(1, 'days').utc(),
          idleForFilter: idleForChoice,
          updatedAtFromFilter: null,
          updatedAtToFilter: null
        }, this.setQueryString)
        break

      default:
        this.setState({
          idleForDate: '',
          idleForFilter: idleForChoice,
          updatedAtFromFilter: null,
          updatedAtToFilter: null
        }, this.setQueryString)
        break
    }
  }

  getFilterStateOnStatusChange = (prevStatus, newStatus) => {
    if (prevStatus === 'unclassified' && newStatus !== 'unclassified') {
      return {
        statusFilter: newStatus,
        createdAtFromFilter: null,
        createdAtToFilter: null,
        // reset filters specific to file listing
        fileTypeFilter: null
      }
    } else if (prevStatus !== 'unclassified' && newStatus === 'unclassified') {
      return {
        orderBy: prevStatus.includes('updated_at')
          ? '-created_at'
          : '',
        statusFilter: newStatus,
        createdAtFromFilter: null,
        createdAtToFilter: null,
        // reset filters specific to file listing
        processedFilter: false,
        // reset filters specific to request listing
        requestTypeFilter: null,
        requestRunOriginFilter: null,
        requestTypeSourceFilter: 'agent_capture',
        updatedAtFromFilter: null,
        updatedAtToFilter: null,
        idleForFilter: null,
        idleForDate: null,
        assignedToFilter: null,
        employerFilter: null,
        divisionFilter: null
      }
    } else {
      return { statusFilter: newStatus }
    }
  }

  getFilters = (employerFilterValue) => {
    let filters =
    // this.state.statusFilter === 'unclassified'
    //   ? [
    //       <FilterSidebarItem
    //         title='File type'
    //         options={
    //           <DynamicPicklist
    //             id='fileType'
    //             query={QUERY_FILETYPE}
    //             field='name'
    //             defaultValue='All'
    //             value={this.state.fileTypeFilter || ''}
    //             onChange={fileType => this.setState({ fileTypeFilter: fileType }, this.setQueryString)}
    //           />
    //         }
    //         key='filter_filetype'
    //       />,
    //       <FilterSidebarItem
    //         title='Processed'
    //         options={
    //           <Picklist
    //             id='processed'
    //             options={[ 'No', 'Yes' ]}
    //             default='No'
    //             symbol='chevrondown'
    //             value={this.state.processedFilter ? 'Yes' : 'No'}
    //             onChange={processed => this.setState({ processedFilter: processed === 'Yes' }, this.setQueryString)}
    //             closeDropdownOnSelect={true}
    //             inline={true}
    //           />
    //         }
    //         key='filter_processed'
    //       />,
    //       <FilterSidebarItem
    //         title='Created between'
    //         options={
    //           <DateRange
    //             startDate={this.state.createdAtFromFilter}
    //             endDate={this.state.createdAtToFilter}
    //             onStartDateChange={date => this.setState({ createdAtFromFilter: date }, this.setQueryString)}
    //             onEndDateChange={date => this.setState({ createdAtToFilter: date }, this.setQueryString)}
    //             startDatePlaceholder='From'
    //             endDatePlaceholder='To'
    //             maxDate={moment()}
    //             dateFormat='DD MMM YYYY, HH:mm'
    //             align='vertical'
    //             showTimeSelect={true}
    //             timeFormat='HH:mm'
    //           />
    //         }
    //         key='filter_createdbetween'
    //       />
    //     ]
    //   :
      [
          <FilterSidebarItem
            title='Request type'
            options={
              <DynamicPicklist
                id='requestType'
                query={QUERY_REQUESTTYPES}
                field='name'
                defaultValue='All'
                value={this.state.requestTypeFilter || ''}
                onChange={requestType => this.setState({ requestTypeFilter: requestType }, this.setQueryString)}
              />
            }
            key='filter_requesttype'
          />,
          <FilterSidebarItem
            title='Source'
            options={
              <PicklistWithData
                id='requestTypeSourceFilter'
                forField='RequestTypeSource'
                default='All'
                symbol='chevrondown'
                value={this.state.requestTypeSourceFilter || ''}
                onChange={requestTypeSource => (
                  this.setState(
                    {
                      requestTypeSourceFilter: requestTypeSource === 'all'
                        ? null
                        : requestTypeSource
                    },
                    this.setQueryString
                  )
                )}
                closeDropdownOnSelect={true}
                inline={true}
              />
            }
            key='filter_source'
          />,
          <FilterSidebarItem
            title='Origin'
            options={
              <PicklistWithData
                id='requestRunOriginFilter'
                forField='RequestRunOrigin'
                default='All'
                symbol='chevrondown'
                value={this.state.requestRunOriginFilter || ''}
                onChange={requestRunOrigin => (
                  this.setState(
                    {
                      requestRunOriginFilter: requestRunOrigin === 'all'
                        ? null
                        : requestRunOrigin
                    },
                    this.setQueryString
                  )
                )}
                closeDropdownOnSelect={true}
                inline={true}
              />
            }
            key='filter_origin'
          />,
          <FilterComboEmployerDivision
            employer={employerFilterValue}
            division={this.state.divisionFilter}
            onEmployerChange={employer => (
              this.setState(
                {
                  employerFilter: employer === 'All'
                    ? null
                    : employer,
                  divisionFilter: null
                },
                this.setQueryString
              )
            )}
            onDivisionChange={division => (
              this.setState(
                {
                  divisionFilter: division === 'All'
                    ? null
                    : division
                },
                this.setQueryString
              )
            )}
            disableEmployerChoice={true}
            disabled={this.state.statusFilter === 'unallocated'}
            key='employerDivisionComboFilter'
          />,
          // <FilterSidebarItem
          //   title='Assigned to'
          //   options={
          //     <Query query={QUERY_CASEHANDLERS}>
          //       {({ loading, error, data }) => {
          //         if (loading) {
          //           return <Spinner size='small' className='slds-is-relative' />
          //         }
          //         if (error) {
          //           return (
          //             <Warning>
          //               Error loading options.
          //             </Warning>
          //           )
          //         }
          //
          //         let caseHandlers = this.getCaseHandlers(data.responsibilities)
          //
          //         return (
          //           <Picklist
          //             id='assignedTo'
          //             options={Object.keys(caseHandlers)}
          //             default='Anyone'
          //             symbol='chevrondown'
          //             value={this.state.assignedToFilter
          //               ? Object.keys(caseHandlers).find(key => caseHandlers[key] === this.state.assignedToFilter)
          //               : 'Anyone'
          //             }
          //             onChange={assignedTo => (
          //               this.setState(
          //                 {
          //                   assignedToFilter: assignedTo === ''
          //                     ? assignedTo
          //                     : caseHandlers[assignedTo]
          //                 },
          //                 this.setQueryString
          //               )
          //             )}
          //             closeDropdownOnSelect={true}
          //             inline={true}
          //           />
          //         )
          //       }}
          //     </Query>
          //   }
          //   key='filter_assignedto'
          // />,
          <FilterSidebarItem
            title='Idle for'
            options={
              <Picklist
                id='idleFor'
                options={[
                  'Any time', 'For more than 14 days', 'For more than 7 days', 'For more than a day'
                ]}
                default='Any time'
                symbol='chevrondown'
                value={this.state.idleForFilter
                  ? this.state.idleForFilter
                  : 'Any time'
                }
                onChange={this.handleIdleForChoice}
                closeDropdownOnSelect={true}
                inline={true}
              />
            }
            key='filter_idlefor'
          />,
          <FilterSidebarItem
            title='Created between'
            options={
              <DateRange
                startDate={this.state.createdAtFromFilter}
                endDate={this.state.createdAtToFilter}
                onStartDateChange={date => this.setState({ createdAtFromFilter: date }, this.setQueryString)}
                onEndDateChange={date => this.setState({ createdAtToFilter: date }, this.setQueryString)}
                startDatePlaceholder='From'
                endDatePlaceholder='To'
                maxDate={moment()}
                dateFormat='DD MMM YYYY, HH:mm'
                align='vertical'
                showTimeSelect={true}
                timeFormat='HH:mm'
              />
            }
            key='filter_createdbetween'
          />,
          <FilterSidebarItem
            title='Last updated between'
            options={
              <DateRange
                startDate={this.state.updatedAtFromFilter}
                endDate={this.state.updatedAtToFilter}
                onStartDateChange={date => this.setState({ updatedAtFromFilter: date }, this.setQueryString)}
                onEndDateChange={date => this.setState({ updatedAtToFilter: date }, this.setQueryString)}
                startDatePlaceholder='From'
                endDatePlaceholder='To'
                maxDate={moment()}
                dateFormat='DD MMM YYYY, HH:mm'
                align='vertical'
                showTimeSelect={true}
                timeFormat='HH:mm'
                disabled={this.state.idleForFilter}
              />
            }
            key='filter_lastupdatedbetween'
          />
        ]

    if (this.props.identityId && this.state.statusFilter !== 'unclassified') {
      filters.splice(3,1)  // removes FilterComboEmployerDivision
    }

    if (this.props.statusFilterInSidebar) {
      // add status filter to top
      filters.unshift(
        <FilterSidebarItem
          title='Status'
          options={
            <Picklist
              id='status'
              options={[ // 'Unclassified' is excluded from this list
                'All',
                // 'Unallocated',  // commented out until needed
                'Uncaptured',
                // 'On hold',  // commented out until needed
                'Unvalidated',
                'Unprocessed',
                'Processing',
                'Processed'
              ]}
              default='All'
              symbol='chevrondown'
              value={this.state.statusFilter
                ? this.getTabLabel(this.state.statusFilter)
                : 'All'
              }
              onChange={status => (
                this.setState(prevState => {
                  let newStatus = this.getTabLabel(status) === 'On hold'
                    ? 'on_hold'
                    : status === 'All'
                      ? null
                      : status.toLowerCase()

                  return this.getFilterStateOnStatusChange(prevState.statusFilter, newStatus)
                }, this.setQueryString)
              )}
              closeDropdownOnSelect={true}
              inline={true}
            />
          }
          key='filter_status'
        />
      )
    }

    return filters
  }

  handleFileClick = (file, filters) => (
    this.props.history.push(`/os/operations/general/files/${file}`, { filters })
  )

  handleRequestRunClick = (identityId, requestRunId, filters, employerId) => (
    identityId === null
      ? this.props.history.push(`/os/operations/general/requests/${requestRunId}`, { filters })
      : this.props.history.push(`/employer/${employerId}/employees/${identityId}/requests/${requestRunId}`, { filters })
  )

  getTabLabel = (status) => ({
    'unclassified': 'Unclassified',
    'unallocated': 'Unallocated',
    'uncaptured': 'Uncaptured',
    'on_hold': 'On hold',
    'unvalidated': 'Unvalidated',
    'unprocessed': 'Unprocessed',
    'processing': 'Processing',
    'processed': 'Processed'
  }[status])

  toggleNewRequestModal = () => (
    this.setState(prevState => ({ showNewRequestModal: !prevState.showNewRequestModal }))
  )

  createRequestRun = (requestrunMutate) => {
    const input = {
      requesttype: this.state.newRequestRequestType,
      identity: this.props.identityId,
      origin: 'form'
    }

    requestrunMutate({ variables: { input } })
      .then(() => {
        console.info('Request run created')
        this.setState({ refreshTimestamp: moment().unix() })
      })
      .catch(error => console.error(`Failed to create request run - ${error}`))
  }

  render() {
    let tabs = [
      // 'Unclassified',  // commented out until needed
      // 'Unallocated',  // commented out until needed
      'Uncaptured',
      // 'On hold',  // commented out until needed
      'Unvalidated',
      'Unprocessed',
      'Processing',
      'Processed'
    ]

    return (
      <div className='stage-main slds-grow slds-scrollable_y' role="main">
        <div className='slds-grid slds-wrap slds-size_1-of-1'>
          <div className='tab-nav slds-size_1-of-1 u-bg-color-white product-listing-page-header'>
            {this.props.title !== null &&
              <div className='slds-p-left_large slds-m-bottom_x-small product-listing-page-header_title'>
                {this.props.title}
              </div>
            }
            {this.props.statusFilterInSidebar
              ? null
              : <TabbedView
                  tabs={tabs}
                  contents={[]}
                  selectedTab={tabs.indexOf(this.getTabLabel(this.state.statusFilter))}
                  onClick={tabIndex => (
                    this.setState(prevState => {
                      let newStatusLabel = tabs[tabIndex]
                      let newStatus = newStatusLabel === 'On hold'
                        ? 'on_hold'
                        : newStatusLabel.toLowerCase()

                      return this.getFilterStateOnStatusChange(prevState.statusFilter, newStatus)
                    }, this.setQueryString)
                  )}
                  tabsClassName='slds-align_absolute-center product-listing-page-header_tabs'
                />
            }
          </div>
          {this.state.showFilesUploadModal &&
            <Modal
              body={
                <BulkFileUploader
                  heading='Upload files'
                  className='slds-m-around_large'
                  onCancel={() => this.setState({ showFilesUploadModal: false })}
                />
              }
            />
          }
          {this.state.showNewRequestModal &&
            <Modal
              heading='New request'
              body={
                <Fragment>
                  <div className='slds-align_absolute-center'>
                    <DynamicPicklist
                      id='newRequestRequestType'
                      query={QUERY_REQUESTTYPES}
                      field='name'
                      placeholder='Choose the type of request'
                      value={this.state.newRequestRequestType}
                      inline={false}
                      onChange={requestType => this.setState({ newRequestRequestType: requestType })}
                      className='slds-size_2-of-3'
                    />
                  </div>
                  <div className='slds-m-top_x-large slds-m-bottom_medium slds-text-align_center'>
                    <Button
                      minWidth={100}
                      onClick={() => {
                        this.toggleNewRequestModal()
                        this.setState({ newRequestRequestType: null })
                      }}>
                      Cancel
                    </Button>
                    <Mutation mutation={MUTATION_REQUESTRUN}>
                      {requestrunMutate => (
                        <Button
                          type='brand'
                          minWidth={100}
                          disabled={this.state.newRequestRequestType === null}
                          onClick={() => {
                            this.createRequestRun(requestrunMutate)
                            this.toggleNewRequestModal()
                          }}>
                          Confirm
                        </Button>
                      )}
                    </Mutation>
                  </div>
                </Fragment>
              }
              contentClassName='overflow-override'
            />
          }
          <AccountContext.Consumer>
            {({ currentAccountId, isEmployerGroupAccount }) => (
              <Fragment>
                <FilterSidebar
                  actions={[
                    <Button
                      onClick={this.toggleNewRequestModal}
                      className='slds-size_1-to-1'
                      key='initiate_new_request'>
                      Initiate new request
                    </Button>
                    // <Button
                    //   onClick={() => this.setState({ showFilesUploadModal: true })}
                    //   className='slds-size_1-of-1'
                    //   key='upload-files'>
                    //   Upload files
                    // </Button>
                  ]}
                  filters={this.getFilters(currentAccountId)}
                  filtersApplied={[
                      this.state.fileTypeFilter || '',
                      this.state.employerFilter || '',
                      this.state.divisionFilter || '',
                      this.state.createdAtFromFilter || this.state.createdAtToFilter
                        ? this.state.createdAtFromFilter
                          ? this.state.createdAtFromFilter.toString()
                          : this.state.createdAtToFilter.toString()
                        : '',
                      this.state.updatedAtFromFilter || this.state.updatedAtToFilter
                        ? this.state.updatedAtFromFilter
                          ? this.state.updatedAtFromFilter.toString()
                          : this.state.updatedAtToFilter.toString()
                        : '',
                      this.state.requestTypeFilter || '',
                      this.state.requestRunOriginFilter || '',
                      this.state.requestTypeSourceFilter || '',
                      this.state.assignedToFilter || '',
                      this.state.idleForFilter || '',
                      this.props.statusFilterInSidebar ? this.state.statusFilter || '' : ''
                    ].filter(filter => filter.length > 0).length
                  }
                  onClear={() => (
                    this.setState({
                      ...{
                        fileTypeFilter: null,
                        employerFilter: null,
                        divisionFilter: null,
                        createdAtFromFilter: null,
                        createdAtToFilter: null,
                        updatedAtFromFilter: null,
                        updatedAtToFilter: null,
                        requestTypeFilter: null,
                        requestTypeSourceFilter: null,
                        requestRunOriginFilter: null,
                        assignedToFilter: null,
                        idleForFilter: null,
                        idleForDate: null
                      },
                      ...this.props.statusFilterInSidebar
                        ? { statusFilter: null }
                        : {}
                    },
                    this.setQueryString)
                  )}
                  componentFilters={true}
                />
                <div className='slds-col slds-size_10-of-12 slds-scrollable_x'>
                  {/* {this.state.statusFilter === 'unclassified'
                    ? <FileList
                        fileType={this.state.fileTypeFilter}
                        createdAtFrom={this.state.createdAtFromFilter
                          ? moment.utc(this.state.createdAtFromFilter).toISOString()
                          : null
                        }
                        createdAtTo={this.state.createdAtToFilter
                          ? moment.utc(this.state.createdAtToFilter).toISOString()
                          : null
                        }
                        processed={this.state.processedFilter}
                        onFileClick={this.handleFileClick}
                        showAllFiles={false}
                        withoutRequestRuns={true}
                        orderBy={this.state.orderBy}
                        changeSort={orderBy => this.setState({ orderBy }, this.setQueryString)}
                        recordsPerPage={this.props.recordsPerPage}
                      />
                    : */}
                  <AccountContext.Consumer>
                    {({ currentAccountId, isEmployerGroupAccount }) => (
                      <RequestRunList
                        identity={this.props.identityId}
                        requestType={this.state.requestTypeFilter}
                        origin={this.state.requestRunOriginFilter}
                        source={this.state.requestTypeSourceFilter}
                        createdAtFrom={this.state.createdAtFromFilter
                          ? moment.utc(this.state.createdAtFromFilter).toISOString()
                          : null
                        }
                        createdAtTo={this.state.createdAtToFilter
                          ? moment.utc(this.state.createdAtToFilter).toISOString()
                          : null
                        }
                        updatedAtFrom={this.state.idleForFilter && this.state.idleForDate
                            ? moment.utc(this.state.idleForDate.toISOString())
                            : this.state.updatedAtFromFilter
                              ? moment.utc(this.state.updatedAtFromFilter).toISOString()
                              : null
                        }
                        updatedAtTo={this.state.updatedAtToFilter
                          ? moment.utc(this.state.updatedAtToFilter).toISOString()
                          : null
                        }
                        employer={currentAccountId}
                        division={this.state.divisionFilter}
                        status={this.state.statusFilter === 'on hold'
                          ? 'on_hold'
                          : this.state.statusFilter
                            ? this.state.statusFilter.toLowerCase()
                            : null
                        }
                        assignedTo={this.state.assignedToFilter}
                        orderBy={this.state.orderBy}
                        changeSort={orderBy => this.setState({ orderBy }, this.setQueryString)}
                        onClick={(identityId, requestRunId, filters) => (
                          this.handleRequestRunClick(identityId, requestRunId, filters, currentAccountId)
                        )}
                        recordsPerPage={this.props.recordsPerPage}
                        showStatusColumn={this.props.showRequestStatusColumn}
                        showExtraEmployerInfo={isEmployerGroupAccount}
                        key={this.state.refreshTimestamp}
                      />
                    )}
                  </AccountContext.Consumer>
                </div>
              </Fragment>
            )}
          </AccountContext.Consumer>
        </div>
      </div>
    )
  }
}

export default withRouter(Requests)



// WEBPACK FOOTER //
// ./src/containers/Requests.js